export const horizontalBarChartDataDashboard = [{
  name: 'Time spent',  
  data: [16, 15, 15, 14, 13, 13, 12, 13, 13, 14, 15, 15, 16]
  }]